@if (enableSwitcher()) {
<div class="mb-3 px-2 sm:px-4 py-3 relative w-full" #tenantContainer>
	<button
		class="w-full flex items-center justify-between text-left p-2 rounded-md hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-primary-500 h-[52px] overflow-hidden"
		(click)="toggleSwitcher.set(!toggleSwitcher())"
	>
		@if (!isNarrow) {
		<div @fadeIn class="tenant-text-info flex-shrink-0 w-[180px]">
			<span class="block text-xs text-slate-400 whitespace-nowrap">Current Tenant</span>
			<span class="block text-sm font-medium text-white whitespace-nowrap overflow-hidden text-ellipsis">{{
				tenantName()
			}}</span>
		</div>
		<mat-icon
			@fadeIn
			class="flex-shrink-0"
			[svgIcon]="
				toggleSwitcher()
					? 'heroicons_outline:chevron-up'
					: 'heroicons_outline:chevron-down'
			"
		></mat-icon>
		} @else if (!isHovering) {
		<mat-icon
			[svgIcon]="'mat_outline:change_circle'"
			class="mx-auto"
		></mat-icon>
		}
	</button>
	<div
		id="tenant-dropdown"
		class="hidden absolute left-0 right-0 mt-2 mx-2 bg-slate-700 border border-slate-600 rounded-md shadow-lg z-50 overflow-hidden"
		[ngClass]="{ hidden: !toggleSwitcher() || isNarrow }"
	>
		<ul class="tenant-dropdown-list max-h-60 overflow-y-auto text-sm py-1">
			@for (company of companies(); track company.companyId) {
			<li>
				<a
					(click)="onSelectCompany(company)"
					class="flex items-center justify-between px-4 py-2 hover:bg-slate-600 text-white cursor-pointer"
					[ngClass]="{
						'bg-primary-500': currentTenant() === company.companyId
					}"
				>
					<div class="flex items-center gap-2">
						@if (primaryTenant() === company.companyId) {
						<mat-icon
							svgIcon="heroicons_outline:home"
							class="icon-size-4"
							[class.text-white]="currentTenant() === company.companyId"
						></mat-icon>
						} @else {
						<mat-icon class="icon-size-4"></mat-icon>
						}

						<span>{{ company.company.name }}</span>
					</div>

					@if (currentTenant() === company.companyId) {
					<mat-icon
						class="icon-size-5 flex-shrink-0 text-white"
						svgIcon="heroicons_outline:check"
					></mat-icon>
					}
				</a>
			</li>
			}
		</ul>
		@if (false) {
		<div
			*hasPermission="['admin:all', 'setting:view', 'setting:viewusers']"
			class="border-t border-slate-600 p-2"
		>
			<button
				class="w-full text-left text-sm px-3 py-2 rounded-md hover:bg-slate-600 text-primary-500 flex items-center add-tenant-button"
				(click)="onCreateTenant()"
			>
				<mat-icon
					class="icon-size-5 mr-2 flex-shrink-0"
					svgIcon="heroicons_outline:plus"
				></mat-icon>

				<span>Add New Tenant</span>
			</button>
		</div>
		}
	</div>
</div>
}
